export function isWinner(status: string | null | undefined): boolean {
  return status === 'winner';
}

export function isSold(status: string | null | undefined): boolean {
  return status === 'sold';
}

export function isUnSold(status: string | null | undefined): boolean {
  return status === 'not_sold';
}
export function isRna(status: string | null | undefined): boolean {
  return status == 'rna';
}
